import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {INewsPost} from '@api/models/news/news';
import {LinkService} from '@core/services/link.service';
import {IUTMParameters, UrlService} from '@utils/services/url/url.service';

@Component({
  selector: 'app-news-link',
  templateUrl: './news-link.component.html',
  styleUrls: ['./news-link.component.scss']
})
export class NewsLinkComponent implements OnChanges {

  public linkTarget: string;
  public hrefLink: string;
  public routerLink: string;
  @Input() private news: INewsPost;
  @Input() private newTab = false;
  @Input() private showWithoutLink = false;
  @Input() public utmParams: IUTMParameters;

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.showWithoutLink) {
      return;
    }
    if (changes.news) {
      const {route, href, newTab} = LinkService.getNewsLink(this.news);

      this.linkTarget = newTab || this.newTab ? '_blank' : '_self';
      if (href) {
        this.hrefLink = UrlService.useUtmParams(href, this.utmParams);
        return;
      }
      this.routerLink = route;
    }
  }
}
